import React from 'react';
import { FaLinkedin } from 'react-icons/fa';  // Import the LinkedIn icon from react-icons

const Footer = () => (
    <footer>
        <p>&copy; 2025 Dr. Amulya Kutikuppala. All rights reserved.</p>
        <ul>
            <li>
                <a href="https://www.linkedin.com/in/dr-amulya-kutikuppala" target="_blank" rel="noopener noreferrer">
                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <FaLinkedin style={{ marginRight: '8px' }} />
                        LinkedIn
                    </span>
                </a>
            </li>
            {/*<li><a href="https://researchgate.net" target="_blank" rel="noopener noreferrer">ResearchGate</a></li>*/}
        </ul>
    </footer>
);

export default Footer;
